// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n3-1";
export var stateContainer = "_n3-0";